export const validationMessages = {
  postError:
    'Hmm, looks like we’re missing something. Can you let us know if we can keep you in the loop by post?',
  voiceError:
    'Hmm, looks like we’re missing something. Can you let us know if we can keep you in the loop by phone?',
  emailError:
    'Hmm, looks like we’re missing something. Can you let us know if we can keep you in the loop via email?',
  messagingError:
    'Hmm, looks like we’re missing something. Can you let us know if we can keep you in the loop via messaging (including SMS)?',
  internetBankingError:
    'Hmm, looks like we’re missing something. Can you let us know if we can keep you in the loop on internet and mobile banking?'
};
